// Lenis smooth scroll init (self-hosted, deferred to avoid render-blocking)
window.lenis = new Lenis();

function raf(time) {
  window.lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);
